import { Accordion } from "@szhsin/react-accordion";
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { LineInputRange } from "ui";

import {
  MAX_PRICE_FILTER_SEARCH_PARAMETER,
  MIN_PRICE_FILTER_SEARCH_PARAMETER
} from "../../../../constants";
import { FilterAccordion } from "../FilterAccordion";
import { PriceFilterProps } from "./PriceFilter.types";

const PriceFilter = ({ minPrice, maxPrice }: PriceFilterProps) => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const minPriceInSearch = searchParams.get(MIN_PRICE_FILTER_SEARCH_PARAMETER);
  const maxPriceInSearch = searchParams.get(MAX_PRICE_FILTER_SEARCH_PARAMETER);
  const priceRangeValues = useMemo(() => {
    return [
      minPriceInSearch ? +minPriceInSearch : minPrice,
      maxPriceInSearch ? +maxPriceInSearch : maxPrice
    ];
  }, [minPriceInSearch, maxPriceInSearch, minPrice, maxPrice]);

  const isClearDisplay =
    (!!minPriceInSearch || !!maxPriceInSearch) &&
    (Number(minPriceInSearch) !== minPrice ||
      Number(maxPriceInSearch) !== maxPrice);

  const handlePriceRangeChange = (values: number[]) => {
    searchParams.set(MIN_PRICE_FILTER_SEARCH_PARAMETER, String(values[0]));
    searchParams.set(MAX_PRICE_FILTER_SEARCH_PARAMETER, String(values[1]));

    setSearchParams(searchParams);
  };

  const clearPriceFilter = () => {
    searchParams.delete(MIN_PRICE_FILTER_SEARCH_PARAMETER);
    searchParams.delete(MAX_PRICE_FILTER_SEARCH_PARAMETER);
    setSearchParams(searchParams);
  };

  useEffect(() => {
    handlePriceRangeChange([minPrice, maxPrice]);
  }, [minPrice, maxPrice]);

  return (
    <Accordion transition transitionTimeout={250}>
      <FilterAccordion
        header={t("Price")}
        isClearDisplay={isClearDisplay}
        onClearClick={clearPriceFilter}
      >
        <LineInputRange
          values={priceRangeValues}
          min={minPrice}
          max={maxPrice > minPrice ? maxPrice : minPrice + 1}
          onChange={handlePriceRangeChange}
        />
      </FilterAccordion>
    </Accordion>
  );
};

export default PriceFilter;
